import { render } from "./LeavePeriodCreateEditModal.vue?vue&type=template&id=f87711d2"
import script from "./LeavePeriodCreateEditModal.vue?vue&type=script&lang=js"
export * from "./LeavePeriodCreateEditModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__